import { render, staticRenderFns } from "./PixelVerificationTopBar.vue?vue&type=template&id=4a8f80f2&scoped=true"
import script from "./PixelVerificationTopBar.vue?vue&type=script&lang=js"
export * from "./PixelVerificationTopBar.vue?vue&type=script&lang=js"
import style0 from "./PixelVerificationTopBar.vue?vue&type=style&index=0&id=4a8f80f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f80f2",
  null
  
)

export default component.exports